import { IBaseInputWithResource } from '@infotech-soe/metaschema';

import IntlService from '../../../../intl/IntlService';
import { IExtendedControl } from '../../../schema-factory/FormSchemaFactory';
import { LocalizedProps } from '../../../view-model/FormControlViewModel';
import { PredefinedForms } from '../../../view-model/FormCreateViewModel';
import { FormSourceType } from '../../../view-model/FormSource';
import { FormViewModel } from '../../../view-model/FormViewModel';

const getLocalizedResource = (
  viewModel: FormViewModel,
  item: IExtendedControl,
  res: string
): Promise<string> => {
  return new IntlService().getFormFieldTitle(
    viewModel.source.category,
    viewModel.source.form,
    item.name || '',
    'action' in viewModel.source ? viewModel.source.action : undefined,
    res
  );
};

export const getLocalizedProps = async (
  viewModel: FormViewModel,
  item: IExtendedControl
): Promise<LocalizedProps> => ({
  label:
    viewModel.source.type === FormSourceType.PREDEFINED &&
    viewModel.source.action !== PredefinedForms.REVIEW
      ? item.name
      : (await getLocalizedResource(
          viewModel,
          item,
          (item as IBaseInputWithResource).resId || item.name
        )) || item.name,
  hint:
    'hint' in item && item.hint
      ? await getLocalizedResource(viewModel, item, item.hint)
      : undefined,
});
